import { render } from "./HomeViewHeader.vue?vue&type=template&id=6d7b93b3"
import script from "./HomeViewHeader.vue?vue&type=script&lang=js"
export * from "./HomeViewHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__